import IconArrowHead from './IconArrowHead';

export const IconSmallRight = {
  component: IconArrowHead,
  props: {
    size: 'small',
    direction: 'right',
  },
  group: 'icons',
};

export const IconSmallDown = {
  component: IconArrowHead,
  props: {
    size: 'small',
    direction: 'down',
  },
  group: 'icons',
};

export const IconSmallLeft = {
  component: IconArrowHead,
  props: {
    size: 'small',
    direction: 'left',
  },
  group: 'icons',
};

export const IconSmallUp = {
  component: IconArrowHead,
  props: {
    size: 'small',
    direction: 'up',
  },
  group: 'icons',
};

export const IconBigRight = {
  component: IconArrowHead,
  props: {
    size: 'big',
    direction: 'right',
  },
  group: 'icons',
};

export const IconBigDown = {
  component: IconArrowHead,
  props: {
    size: 'big',
    direction: 'down',
  },
  group: 'icons',
};

export const IconBigLeft = {
  component: IconArrowHead,
  props: {
    size: 'big',
    direction: 'left',
  },
  group: 'icons',
};

export const IconBigUp = {
  component: IconArrowHead,
  props: {
    size: 'big',
    direction: 'up',
  },
  group: 'icons',
};

export const IconTinyRight = {
  component: IconArrowHead,
  props: {
    size: 'tiny',
    direction: 'right',
  },
  group: 'icons',
};

export const IconTinyDown = {
  component: IconArrowHead,
  props: {
    size: 'tiny',
    direction: 'down',
  },
  group: 'icons',
};

export const IconTinyLeft = {
  component: IconArrowHead,
  props: {
    size: 'tiny',
    direction: 'left',
  },
  group: 'icons',
};

export const IconTinyUp = {
  component: IconArrowHead,
  props: {
    size: 'tiny',
    direction: 'up',
  },
  group: 'icons',
};
